import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { BROWSER_IS_WORKS } from '#modules/browser';
import UnauthorizedScene from '#scenes/unauthorized';
import { PageContext } from './contexts';

PageProvider.propTypes = {
  requires: PropTypes.array,
  language: PropTypes.oneOf(['en_US', 'ko_KR', 'ja_JP', 'zh_CN', 'zh_TW'])
    .isRequired,
  gnbBackgroundColor: PropTypes.string,
  gnbFontColor: PropTypes.string,
  menuDisplay: PropTypes.object,
  hasCampaignCodeBanner: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
export default function PageProvider({
  requires = [],
  language,
  gnbBackgroundColor,
  gnbFontColor,
  menuDisplay = {},
  hasCampaignCodeBanner = false,
  children,
}) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    Promise.all(requires).then(() => setReady(true));
  }, []);

  if (!ready) return null;
  return (
    <PageContext.Provider
      value={{
        language,
        gnbBackgroundColor,
        gnbFontColor,
        menuDisplay,
        hasCampaignCodeBanner,
      }}
    >
      <div
        className={classNames('wrap', language, {
          ua_win: navigator.platform.includes('Win'),
        })}
      >
        {BROWSER_IS_WORKS ? <UnauthorizedScene /> : children}
      </div>
    </PageContext.Provider>
  );
}
